import * as React from "react";
import { styled } from "@mui/material";
import { VerticalDivider } from "./verticalDivider";
import { AlertMessage } from "./AlertMessage";
import { MedicalDataDisplaySection } from "./MedicalDataDisplay";
import { clinicScrollableStyle } from "fe-common/ui/commonStyles";

//region [[ Styles ]]
const PatientDataColumnsScroll = styled("div")({
  height: "100%",
  minWidth: "100%",
  overflow: "auto",
  paddingRight: 10,
  direction: "ltr",
  ...clinicScrollableStyle,
});
const PatientDataColumnsView = styled("div")({
  display: "flex",
  justifyContent: "start",
  alignItems: "start",
  minHeight: 70,
  flexDirection: "row",
  gap: 20,
  flex: 1,
  minWidth: "100%",
  padding: "20px 4px",
  "& .column-section": {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    position: "relative",
    height: "100%",
  },
  "& .summary-column": {
    flex: 2,
  },
  "& .llm-card-column-header": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: 36,
    "&:not(:first-child)": {
      marginTop: 16,
    },
  },
  "& .column-content": {
    flex: "1",
  },
  "& .dd-column .column-content": {
    marginTop: 16,
  },
  "& .section-title": {
    display: "flex",
    flexFlow: "row",
    alignItems: "center",
  },

  "& .section-area-with-copy": {
    padding: 0,
  },
  "& .patient-card-dd-view": {
    maxHeight: "100%",
  },
});
//endregion [[ Styles ]]

//region [[ Props ]]

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const MedicalDataDisplayColumns = ({
  summarySection,
  ddSection,
  assessmentSection,
  workupSection,
  error,
  showDD,
  showInsights,
  loading,
  rtlDisplay,
}: MedicalDataDisplaySection) => {
  if (loading)
    return (
      <PatientDataColumnsView className="patient-data-columns"></PatientDataColumnsView>
    );
  return (
    <PatientDataColumnsScroll className="patient-data-scroll">
      <PatientDataColumnsView
        className="patient-data-columns"
        style={rtlDisplay ? { direction: "rtl" } : null}
      >
        <div className="column-section summary-column">{summarySection}</div>
        {error ? (
          <>
            <VerticalDivider />
            <div className="column-section dd-column error">
              <AlertMessage message={error} />
            </div>
          </>
        ) : (
          showInsights && (
            <>
              {showDD && (
                <>
                  <VerticalDivider />
                  {ddSection}
                </>
              )}
              <VerticalDivider />
              <div
                className={"column-section last-column assessment-section"}
                style={{ gap: 10 }}
              >
                {assessmentSection}
                {workupSection}
              </div>
            </>
          )
        )}
      </PatientDataColumnsView>
    </PatientDataColumnsScroll>
  );
};
